var map = {
	"./AutoTranslationSettings": 46,
	"./AutoTranslationSettings.coffee": 46,
	"./CostSimulator": 48,
	"./CostSimulator.coffee": 48,
	"./Glossary": 49,
	"./Glossary.coffee": 49,
	"./History": 50,
	"./History.coffee": 50,
	"./ManageLanguages": 51,
	"./ManageLanguages.coffee": 51,
	"./NavbarDigestButton": 52,
	"./NavbarDigestButton.coffee": 52,
	"./ProjectsListing": 53,
	"./ProjectsListing.coffee": 53,
	"./TeamMembers": 54,
	"./TeamMembers.coffee": 54,
	"./TranslationInterface": 55,
	"./TranslationInterface.coffee": 55,
	"./glossary/Term": 11,
	"./glossary/Term.coffee": 11,
	"./glossary/TermForm": 12,
	"./glossary/TermForm.coffee": 12,
	"./history/Comment": 13,
	"./history/Comment.coffee": 13,
	"./history/PastSegment": 14,
	"./history/PastSegment.coffee": 14,
	"./history/SourceEdit": 15,
	"./history/SourceEdit.coffee": 15,
	"./history/shared/Date": 4,
	"./history/shared/Date.coffee": 4,
	"./projects_listing/BlankSlate": 17,
	"./projects_listing/BlankSlate.coffee": 17,
	"./projects_listing/Project": 19,
	"./projects_listing/Project.coffee": 19,
	"./projects_listing/Search": 16,
	"./projects_listing/Search.coffee": 16,
	"./projects_listing/Sidebar": 18,
	"./projects_listing/Sidebar.coffee": 18,
	"./projects_listing/Summary": 23,
	"./projects_listing/Summary.coffee": 23,
	"./projects_listing/project/Bars": 21,
	"./projects_listing/project/Bars.coffee": 21,
	"./projects_listing/project/Dropdown": 20,
	"./projects_listing/project/Dropdown.coffee": 20,
	"./projects_listing/project/Users": 22,
	"./projects_listing/project/Users.coffee": 22,
	"./projects_listing/project/bars/Bar": 8,
	"./projects_listing/project/bars/Bar.coffee": 8,
	"./translation_interface/BlankSlate": 40,
	"./translation_interface/BlankSlate.coffee": 40,
	"./translation_interface/Context": 27,
	"./translation_interface/Context.coffee": 27,
	"./translation_interface/FacetedSearch": 43,
	"./translation_interface/FacetedSearch.coffee": 43,
	"./translation_interface/History": 30,
	"./translation_interface/History.coffee": 30,
	"./translation_interface/Memory": 28,
	"./translation_interface/Memory.coffee": 28,
	"./translation_interface/Panel": 34,
	"./translation_interface/Panel.coffee": 34,
	"./translation_interface/Search": 24,
	"./translation_interface/Search.coffee": 24,
	"./translation_interface/Segments": 41,
	"./translation_interface/Segments.coffee": 41,
	"./translation_interface/SelectionStats": 39,
	"./translation_interface/SelectionStats.coffee": 39,
	"./translation_interface/SelectionTags": 38,
	"./translation_interface/SelectionTags.coffee": 38,
	"./translation_interface/blank_slate/ProjectConfigCode": 6,
	"./translation_interface/blank_slate/ProjectConfigCode.coffee": 6,
	"./translation_interface/helpers/Colors": 2,
	"./translation_interface/helpers/Colors.coffee": 2,
	"./translation_interface/history/Comment": 31,
	"./translation_interface/history/Comment.coffee": 31,
	"./translation_interface/history/PastSegment": 32,
	"./translation_interface/history/PastSegment.coffee": 32,
	"./translation_interface/history/SourceEdit": 33,
	"./translation_interface/history/SourceEdit.coffee": 33,
	"./translation_interface/memory/MemoryResult": 29,
	"./translation_interface/memory/MemoryResult.coffee": 29,
	"./translation_interface/panel/IcuPlural": 37,
	"./translation_interface/panel/IcuPlural.coffee": 37,
	"./translation_interface/panel/Plural": 36,
	"./translation_interface/panel/Plural.coffee": 36,
	"./translation_interface/panel/Singular": 35,
	"./translation_interface/panel/Singular.coffee": 35,
	"./translation_interface/panel/helpers/PanelHelpers": 1,
	"./translation_interface/panel/helpers/PanelHelpers.coffee": 1,
	"./translation_interface/segments/Segment": 25,
	"./translation_interface/segments/Segment.coffee": 25,
	"./translation_interface/segments/segment/Tags": 26,
	"./translation_interface/segments/segment/Tags.coffee": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;